import { gql } from "@apollo/client";

export const CREATE_NOTES_MUTATION = gql`
  mutation CreateNote($input: CreateNoteInput!) {
    CreateNote(input: $input)
  }
`;

export const EDIT_NOTES_MUTATION = gql`
  mutation EditNote($input: EditNoteInput!) {
    EditNote(input: $input)
  }
`;

export const DELETE_NOTES_MUTATION = gql`
  mutation DeleteNote($id: Int!) {
    DeleteNote(id: $id)
  }
`;

export const CREATE_PRODUCT_SYSTEM_MUTATION = gql`
  mutation CreateProductSystem($input: CreateProductSystemInput!) {
    createProductSystem(input: $input)
  }
`;

export const UPDATE_PRODUCT_SYSTEM_MUTATION = gql`
  mutation updateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input)
  }
`;

export const CREATE_MATERIAL_CATEGORY = gql`
  mutation CreateMaterialCategory($input: CreateMaterialCategoryInput!) {
    createMaterialCategory(input: $input)
  }
`;

export const UPDATE_MATERIAL_CATEGORY = gql`
  mutation updateMaterialCategory($input: UpdateMaterialCategoryInput!) {
    updateMaterialCategory(input: $input)
  }
`;

export const CREATE_MISC_FIELD = gql`
  mutation CreateMiscField($input: CreateMiscFieldInput!) {
    createMiscField(input: $input)
  }
`;

export const CREATE_LABOR_MEASUREMENT = gql`
  mutation CreateLaborMeasurement($input: CreateLaborMeasurementInput!) {
    createLaborMeasurement(input: $input)
  }
`;

export const UPDATE_LABOR_MEASUREMENT = gql`
  mutation updateLaborMeasurement($input: UpdateLaborMeasurementInput!) {
    updateLaborMeasurement(input: $input)
  }
`;

export const CREATE_MATERIAL_MEASUREMENT = gql`
  mutation CreateMaterialMeasurement($input: CreateMaterialMeasurementInput!) {
    createMaterialMeasurement(input: $input)
  }
`;

export const UPDATE_MATERIAL_MEASUREMENT = gql`
  mutation updateMaterialMeasurement($input: UpdateMaterialMeasurementInput!) {
    updateMaterialMeasurement(input: $input)
  }
`;

export const UPDATE_MATERIAL_MEASUREMENT_ORDER = gql`
  mutation UpdateMaterialMeasurementOrder($newOrder: [Int!]!) {
    updateMaterialMeasurementOrder(newOrder: $newOrder)
  }
`;

export const UPDATE_LABOR_MEASUREMENT_ORDER = gql`
  mutation UpdateLaborMeasurementOrder($newOrder: [Int!]!) {
    updateLaborMeasurementOrder(newOrder: $newOrder)
  }
`;

export const CREATE_CONTRACTOR_REPORT = gql`
  mutation CreateContractorReport($input: CreateContractorReportInput!) {
    createContractorReport(input: $input)
  }
`;

export const CREATE_CONTRACTOR = gql`
  mutation CreateContractor($input: CreateContractorInput!) {
    createContractor(input: $input)
  }
`;

export const UPDATE_CONTRACTOR = gql`
  mutation UpdateContractor($input: UpdateContractorInput!) {
    updateContractor(input: $input)
  }
`;

export const CREATE_LABOR = gql`
  mutation CreateLabor($input: CreateLaborInput!) {
    createLabor(input: $input)
  }
`;

export const UPDATE_LABOR = gql`
  mutation updateLabor($input: UpdateLaborInput!) {
    updateLabor(input: $input)
  }
`;

export const CREATE_CONTRACTOR_ORDER = gql`
  mutation CreateContractorOrder($input: CreateContractorOrderInput!) {
    createContractorOrder(input: $input)
  }
`;

export const ARCHIVE_PRODUCT_SYSTEM_MUTATION = gql`
  mutation ToggleArchiveStatusProduct($productSystemId: Int!) {
    ToggleArchiveStatusProduct(productSystemId: $productSystemId)
  }
`;

export const ARCHIVE_MATERIAL_CATEGORY = gql`
  mutation ArchiveMaterialCategory($materialCategoryId: Int!) { 
    ArchiveMaterialCategory(materialCategoryId: $materialCategoryId)
  }
`;

export const ARCHIVE_MATERIAL_MEASUREMENT = gql`
  mutation ArchiveMaterialMeasurement($materialMeasurementId: Int!) {
    ArchiveMaterialMeasurement(materialMeasurementId: $materialMeasurementId)
  }
`;

export const ARCHIVE_MATERIAL = gql`
  mutation ArchiveMaterial($materialId: Int!) {
    ArchiveMaterial(materialId: $materialId)
  }
`;

export const ARCHIVE_LABOR_MEASUREMENT = gql`
  mutation ArchiveLaborMeasurement($laborMeasurementId: Int!) {
    ArchiveLaborMeasurement(laborMeasurementId: $laborMeasurementId)
  }
`;

export const ARCHIVE_CONTRACTOR = gql`
  mutation ArchiveContractor($contractorId: Int!) {
    ArchiveContractor(contractorId: $contractorId)
  } 
`;

export const ARCHIVE_LABOR = gql`
  mutation ArchiveLabor($laborId: Int!) {
    ArchiveLabor(laborId: $laborId)
  }
`;

export const ARCHIVE_MISC_FIELD = gql`
  mutation ArchiveMiscellaneousField($mescFieldId: Int!) {
    ArchiveMiscellaneousField(mescFieldId: $mescFieldId)
  }
`;

export const EDIT_PRODUCT_SYSTEM = gql`
  mutation UpdateProductSystem($input: updateProductSystemInput!) {
    updateProductSystem(input: $input)
  }
`;

export const CREATE_TAG = gql`
  mutation CreateTag($tag: String!) {
    CreateTag(tag: $tag)
  }
`;

export const UPDATE_TAG = gql`
  mutation UpdateTag($id: Int!, $name: String!) {
    UpdateTag(id: $id, name: $name)
  }
`;

export const DELETE_TAG = gql`
  mutation DeleteTag($id: Int!) {
    DeleteTag(id: $id)
  }
`;

export const DELETE_LABOR_VARIANT = gql`
  mutation DeleteLaborVariant($id: Int!) {
    DeleteLaborVariant(id: $id)
  }
`;